<script>
    export let type = 'tab';
</script>

<button class={type} >
    <slot></slot>
</button>

<style>
    button{
        border: 0;
        cursor: pointer;
        font-weight: bold;
    }
    
    .tab{
        background-color: rgb(255, 196, 0);
        color: black;
    }
    .gen{
        background-color: rgb(9, 255, 0);
    }
</style>